import { Icon } from "./icon";

export const CaretDown = () => {
  return (
    <button type="button">
      <Icon svg="caret-down" width={24} height={24} />
    </button>
  );
};
